import axios from 'axios';

import { appStore as store } from '../index';

import { cookie, decrementBlockCounter, incrementBlockCounter, unBlockUi } from '../actions/actionCreator';
import AuthInterceptor from '../utils/AuthInterceptor';
import CacheBuster from '../utils/CacheBuster';

var eapiClient = axios.create({
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=-1, private'
  }
});
eapiClient.defaults.headers.post['Content-Type'] = 'application/json';
eapiClient.defaults.headers.put['Content-Type'] = 'application/json';
eapiClient.defaults.timeout = 300000;
eapiClient.defaults.withCredentials = true;

// Add a EAPI request interceptor
const ejectEAPIRequestInterceptorRef = eapiClient.interceptors.request.use(function (config) {
  // busting cache
  let setCurrentLang = store.getState().lang.currentLang
  CacheBuster.bust({ ...config, ...setCurrentLang });

  // attaching auth token
  AuthInterceptor.attachToken(config);

  //configuring blocker
  if (config.noBlocking === undefined || config.noBlocking === false) {
    store.dispatch(incrementBlockCounter());
  }
  return config;
}, function (error) {
  store.dispatch(unBlockUi());
  return Promise.reject(error);
});

// get cookie value
function getCookie(c_name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=");
    if (c_start !== -1) {
      c_start = c_start + c_name.length + 1;
      var c_end = document.cookie.indexOf(";", c_start);
      if (c_end === -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

// Add a EAPI response interceptor
const ejectEAPIResponseInterceptorRef = eapiClient.interceptors.response.use(function (response) {
  var cookieValue = getCookie('expiration')
  store.dispatch(cookie(cookieValue.split('"')[1]))
  // Interval time for popup
  if (response.config.noBlocking === undefined || response.config.noBlocking === false) {
    store.dispatch(decrementBlockCounter());
  }
  if (response.headers['content-type'].indexOf('text/html') >= 0) {
    if (store.getState().auth.userDetails !== undefined && store.getState().auth.userDetails.customer) {
      window.location.assign('/login');
    }
    else {
      window.location.assign('/logout');
    }
  }
  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    let customer = window.localStorage.getItem("customer");
    if ((store.getState().auth.userDetails !== undefined && store.getState().auth.userDetails.customer) || customer === 'true') {
      window.location.assign('/login');
    }
    else if (store.getState().customerIncorrectCredentials === undefined) {
      window.location.assign('/logout');
    }
  } else {
    if (!error.response) {
      console.log('Something went wrong: ', error);
    }
  }
  store.dispatch(unBlockUi());
  return Promise.reject(error);
});


// const bustCache = (url) => `${url}?cacheBuster=${new Date().getTime()}`;

export { eapiClient, ejectEAPIRequestInterceptorRef, ejectEAPIResponseInterceptorRef };




// WEBPACK FOOTER //
// ./src/restClient/eapiRestClient.js